<template>
  <div>
    <fs1-div v-if="!selectedItem.length && view_only">Sin imagenes</fs1-div>
    <in_img
      :container="selectedItem"
      c_key="picture"
      style="display: inline-block;"
      :multiple="true"
      :on_add="add_img"
      :on_remove="remove_img"
      :disabled="view_only"
      :auth_file_endpoint="authFileEndpoint"/>
    </div>
</template>

<script>
import in_img from '@/components/inputs/in-img.vue';
import { AC } from '@/config';
export default {
  props:['selectedItem','merge_item','view_only','name','post_name','delete_name'],
  components:{ in_img },
  computed:{
    c_post_name(){ return this.post_name || `${this.name}/a/all` },
    c_delete_name(){ return this.delete_name || `${this.name}/a` },
    authFileEndpoint() {
      const key = `${this.name || ''} ${this.post_name || ''} ${this.delete_name || ''} ${this.c_post_name || ''}`;
      if (key.includes('critical_asset_images')) return `${AC}/critical_asset_images/`;
      if (key.includes('spare_part_image')) return `${AC}/spare_part_image/`;
      return `${AC}/action_photographic_record/`;
    },
  },
  methods:{
    add_img(picture, data){
      const file = picture instanceof File ? picture : (picture && picture.picture);
      const sv = Object.assign({picture: file},{...this.merge_item});
      return this.requests.post[this.c_post_name](sv)
        .then(r=>{
          if (r && r.id && this.selectedItem.some(item => item && item.id === r.id)) {
            if (data && data.removePreview) data.removePreview();
            return r;
          }
          if (r && typeof r === 'object' && !Array.isArray(r)) this.selectedItem.push(r);
          this.dev_log(data);
          if (data && data.removePreview) data.removePreview();
          return r;
        })
    },
    remove_img(picture) {
      this.dev_log({picture});
      this.requests.delete[this.c_delete_name](picture.id)
        .then(r=>this.dev_log({r}))
    }
  }
};
</script>
